/**
 * Data Trans Payment Button Deposit Config
 */

define(function(require, exports, module) {

    module.exports = {
        defaultConfig: {
            useGooglePay: false,
            useApplePay: false,
            merchantId: '1000011011',
            merchantName: 'Test',
            tokenOnly: false,
            autoSettle: true,
            auto: true,
            allowedCardNetworks: ['AMEX', 'DISCOVER', 'MASTERCARD', 'VISA'],
            googlePayConfiguration: {
                buttonType: 'short',
                buttonStyle: 'black',
                merchantId: '01234567890123456789'
            },
            applePayConfiguration: {
                buttonType: "plain",
                buttonStyle: "black"
            }
        },
        getPayment: function(options) {
            return {
                // W3C spec
                details: {
                    total: {
                        label: options.label,
                        amount: {
                            value: options.amount,
                            currency: options.currencyCode
                        }
                    }
                },
                // W3C spec
                options: {
                    requestPayerEmail: false,
                    requestPayerName: false,
                    requestPayerPhone: false,
                    requestShipping: false
                },
                // Datatrans specific
                transaction: {
                    countryCode: options.countryCode,
                    refno: options.transactionReference,
                    createAlias:false
                }
            };
        }
    };
});
